import api from "../lib/api";
import { itDate, eur } from "../lib/constants";
import { TASK_META, statusInfo, nextStatus } from "./TaskDialog";
import { toast } from "sonner";
import { ChevronRight } from "lucide-react";

const today = () => new Date().toLocaleDateString("sv-SE");

const lines = (t) => {
  if (t.kind === "richiamo") return [t.title || t.client_name, [t.date && itDate(t.date), t.time, t.title && t.client_name].filter(Boolean).join(" · ")];
  if (t.kind === "materiale") return [t.material, [t.quantity, t.supplier_name || t.supplier, t.amount ? eur(t.amount) : "", t.payment_due && `pag. ${itDate(t.payment_due)}`, t.client_name].filter(Boolean).join(" · ")];
  return [t.client_name || t.product, [t.client_name && t.product, t.due_date && `entro ${itDate(t.due_date)}`].filter(Boolean).join(" · ")];
};

export function TaskRow({ t, onOpen, onChanged }) {
  const [, label, bg, fg] = statusInfo(t.kind, t.status);
  const nx = nextStatus(t.kind, t.status);
  const [main, sub] = lines(t);
  const d = t.kind === "richiamo" ? t.date : t.kind === "preventivo" ? t.due_date : "";
  const late = d && d < today() && nx;
  const advance = async (e) => {
    e.stopPropagation();
    try { await api.put(`/tasks/${t.id}`, { status: nx[0] }); toast.success(`Segnato come "${nx[1]}"`); if (t.kind === "preventivo" && !t.quote_id && ["pronto", "inviato"].includes(nx[0])) toast.info("Creata una bozza nella sezione Preventivi"); onChanged(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Aggiornamento non riuscito"); }
  };
  return (
    <div data-testid={`task-row-${t.id}`} onClick={() => onOpen(t)}
      className={`flex items-center gap-2 p-3 rounded-lg cursor-pointer transition-colors hover:bg-accent ${late ? "bg-red-50" : "bg-slate-50"}`}>
      <div className="min-w-0 flex-1">
        <p className={`font-medium text-sm truncate ${nx ? "" : "line-through text-muted-foreground"}`}>{main || "—"}</p>
        {sub && <p className={`text-xs truncate ${late ? "text-destructive" : "text-muted-foreground"}`}>{late ? "In ritardo · " : ""}{sub}</p>}
      </div>
      {t.paid && <span data-testid={`task-paid-${t.id}`} className="text-[11px] px-2 py-0.5 rounded-full font-semibold bg-emerald-600 text-white">Pagato</span>}
      <span className="text-[11px] px-2 py-0.5 rounded-full font-semibold whitespace-nowrap" style={{ background: bg, color: fg }}>{label}</span>
      {nx && <button data-testid={`task-advance-${t.id}`} onClick={advance} className="text-[11px] px-2 py-1 rounded-full border border-ink/20 bg-white hover:bg-ink hover:text-white transition-colors whitespace-nowrap flex items-center">{nx[1]}<ChevronRight size={12} /></button>}
    </div>
  );
}

export function TaskList({ items, onOpen, onChanged, empty, kind }) {
  if (!items.length) return <p className="text-sm text-muted-foreground py-2" data-testid={`task-empty-${kind}`}>{empty}</p>;
  return <div className="space-y-2" data-testid={`task-list-${kind}`}>{items.map((t) => <TaskRow key={t.id} t={t} onOpen={onOpen} onChanged={onChanged} />)}</div>;
}

export const addLabel = (kind) => TASK_META[kind].add;
